export default __webpack_public_path__ + "static/media/Wallet-Desktop.5ea6f379.png";